import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@fluentui/react-components';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { StatusScreen } from '#src/shared/StatusScreen.js';
/**
 * Erro ao carregar ou renderizar uma rota. Sem isto, o React Router mostra a
 * própria tela de erro, em inglês e sem o tema.
 */
export function RouteError() {
    const error = useRouteError();
    const description = isRouteErrorResponse(error)
        ? `${error.status} ${error.statusText}`
        : error instanceof Error
            ? error.message
            : undefined;
    return (_jsx(StatusScreen, { tone: "error", title: "Algo deu errado nesta p\u00E1gina", ...(description === undefined ? {} : { description }), action: _jsx(Button, { appearance: "primary", onClick: () => window.location.reload(), children: "Recarregar" }) }));
}
//# sourceMappingURL=RouteError.js.map